export default __webpack_public_path__ + "99c7dcfd2cdf4b133e40d3412de14ead.png";